/**
 * Formats a number by rounding it to a maximum number of decimal places,
 * and returns the shortest possible string representation (removes trailing zeros)
 *
 * Examples:
 * - formatSmartRounded(5, 1) → "5"
 * - formatSmartRounded(5.1, 1) → "5.1"
 * - formatSmartRounded(5.129, 2) → "5.13"
 *
 * @param value - The number to format
 * @param maxDecimals - Maximum number of decimal digits to retain (default is 1)
 * @returns A string representing the rounded number without unnecessary trailing zeros
 */
export const formatSmartRounded = (
  value: number,
  maxDecimals: number = 1
): string => {
  const factor = Math.pow(10, maxDecimals);
  const rounded = Math.round(value * factor) / factor;
  return rounded.toString();
};
